export default __webpack_public_path__ + "static/media/healthybaltimore.9865c2f5.png";